module.exports = __webpack_public_path__ + "fonts/Calibre-Semibold.34780840.woff";